import { ref } from 'vue'
import { createI18n } from 'vue-i18n'
import translationService from '../src/services/translation'
import store from '../src/store/index'
import { toVueI18n9Messages } from './utils/i18nMessages'

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: store.getters['Auth/currentLanguage'],
  fallbackLocale: 'en',
  messages: {}
});

/* vue-i18n 9, anahtar STRING DEĞİLSE `SyntaxError: Invalid argument` atar (8 yalnız uyarıp boş string
   dönüyordu); render içindeki tek eksik alan ekranın tamamını düşürür. Estesoft.App main.js'teki
   sigortanın kopyası: legacy modda her bileşenin `$t`'si çağrı anında bu composer'a iner. */
const translate = i18n.global.t.bind(i18n.global);
i18n.global.t = function (key, ...rest) {
  if (typeof key !== 'string' || key.length === 0) {
    if (process.env.NODE_ENV !== 'production' && key !== null && key !== undefined && key !== '')
      console.warn('i18n: anahtar string değil, boş metin döndürüldü:', key);

    return '';
  }

  return translate(key, ...rest);
};

// Çeviriler HubApi'den asenkron gelir; ilk ekran (giriş) ham anahtar göstermemek için bunu bekler.
export const translationsLoaded = ref(false);

translationService.getAllTranslations()
  .then((response) => {
    for (const lang in response) {
      if (Object.prototype.hasOwnProperty.call(response, lang)) {
        i18n.global.setLocaleMessage(lang, toVueI18n9Messages(response[lang]));
      }
    }
  })
  .catch(error => {
    console.error(error);
  })
  .finally(() => {
    translationsLoaded.value = true;
  });

export default i18n;
